import {useQuery} from "react-query";
import MonthlyWeightShippedApi from "./MonthlyWeightShipped.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useMonthlyWeightShipped(query:IWidgetQuery){
    return useQuery(["fetchMonthlyWeightShipped", query], MonthlyWeightShippedApi.getData);
}